module.exports = __webpack_public_path__ + "img/ic_bid.87b744f5.svg";